import { Box, Button, FormControlLabel, IconButton, Stack, Switch, TextField, Typography } from '@mui/material';

import { useDebouncedBlockContent } from '@/hooks/use-debounced-block-content';
import type { ListBlockContent } from '@/types/database';

export function ListBlockEditPanel({
  content,
  onUpdate,
}: {
  content: ListBlockContent;
  onUpdate: (content: ListBlockContent) => void;
}) {
  const [draft, update] = useDebouncedBlockContent(content || { items: [] }, onUpdate);
  const items: string[] = draft.items || [];

  const addItem = () => update({ ...draft, items: [...items, ''] }, { immediate: true });

  const updateItem = (index: number, value: string) => {
    const updated = [...items];
    updated[index] = value;
    update({ ...draft, items: updated });
  };

  const removeItem = (index: number) => {
    update({ ...draft, items: items.filter((_, itemIndex) => itemIndex !== index) }, { immediate: true });
  };

  return (
    <Stack spacing={1.5}>
      <TextField
        label="Heading"
        value={draft.heading || ''}
        onChange={(event) => update({ ...draft, heading: event.target.value })}
        fullWidth
      />
      <Stack spacing={1}>
        {items.map((item, index) => (
          <Stack key={index} direction="row" spacing={1}>
            <TextField value={item} onChange={(event) => updateItem(index, event.target.value)} label={`Item ${index + 1}`} fullWidth />
            <IconButton onClick={() => removeItem(index)}>
              <Typography variant="caption">Delete</Typography>
            </IconButton>
          </Stack>
        ))}
      </Stack>
      <Box>
        <Button variant="outlined" size="small" onClick={addItem}>Add Item</Button>
      </Box>
      <FormControlLabel
        control={
          <Switch
            checked={draft.dense ?? false}
            onChange={(event) => update({ ...draft, dense: event.target.checked }, { immediate: true })}
          />
        }
        label="Dense"
      />
    </Stack>
  );
}
